module.exports = __webpack_public_path__ + "images/style-5-229793a7a9cf30b96e05009a77989b31.jpg";